// extracted by mini-css-extract-plugin
export default {"firstSessionModal_container":"Os","firstSessionModal_header":"Ps","firstSessionModal_title":"Qs","firstSessionModal_header_tex":"Rs","firstSessionModal_video":"Ss","firstSessionModal_videoContent":"Ts","firstSessionModal_FAQ":"Us","firstSessionModal_FAQMargin":"Vs","firstSessionModal_FAQTitle":"Ws","firstSessionModal_buttonContainer":"Xs","firstSessionModal_buttonText":"Ys","firstSessionModal_SMSBtn_mob":"Zs"};
    if(module.hot) {
      // 1711717530806
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  